<ng-container *ngIf="!hide">
    <prcins-mobile-selector *ngIf="!isLarge; else large" [registeredPolicies]="allowedPolicies" [isHome]="isHome"
        [noSelector]="noSelector" (policySelected)="onPolicySelected($event)"></prcins-mobile-selector>
    <ng-template #large>
        <prcins-desktop-selector [registeredPolicies]="allowedPolicies" [isHome]="isHome" [noSelector]="noSelector"
            (policySelected)="onPolicySelected($event)">
        </prcins-desktop-selector>
    </ng-template>
</ng-container>